import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../redux/store';
import { editCommand } from "../../../redux/actions/commands.actions";
import { useSearchParams } from "react-router-dom";
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import ModalShell from "../../../components/common/Modals/ModalShell";
import { clearError } from "../../../redux/reducers/commands.reducer";

const UpdateCommandModal: React.FC<ModalProps> = ({open, setOpen,object}) => {
    const searchParams = useSearchParams()[0];
    const command = object;

    const handleClose = () => {
      handleReset();
      setOpen(false);
    };

    const handleReset = () => {
      dispatch(clearError());
      setSubmitted(false);
      setTitle('');
      setBody('');
    };

    const dispatch = useDispatch<AppDispatch>();
    const { accessToken } = useSelector((state: RootState) => state.user);
    const { error, loading } = useSelector((state: RootState) => state.commands);

    const [submitted, setSubmitted] = useState(false);
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');

    useEffect(() => {
      if (command){
        setTitle(command.title);
        setBody(JSON.stringify(command.body));
      }
    }, [command]);

    const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault();

      setSubmitted(true);

      await dispatch(editCommand({id:command?.id,title:title, body:body, params:searchParams.toString()}));
    };

  const editing = !submitted || loading;

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      size={editing ? "md" : "sm"}
      busy={submitted && loading}
      tone={editing ? undefined : error ? "error" : "success"}
      title={editing ? (submitted && loading ? "Updating command…" : "Edit command") : error ? "An error occurred" : "Command updated"}
      subtitle={editing && command?.title ? command.title : undefined}
      actions={editing ?
        <>
          <button className="btn" onClick={handleClose}>Cancel</button>
          <button className="btn btn-primary" disabled={loading || !accessToken} onClick={handleSubmit}>
            {loading ? "Updating…" : "Update"}
          </button>
        </>
        : error ?
        <>
          <button className="btn" onClick={handleClose}>Close</button>
          <button className="btn btn-primary" onClick={handleReset}>Try again</button>
        </>
        :
        <button className="btn btn-primary" onClick={handleClose}>OK</button>
      }
    >
      {editing ?
        <form className="dlg-section" onSubmit={handleSubmit}>
          <div className="field">
            <label className="field-label" htmlFor="title">Title</label>
            <input
              id="title"
              className="input"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
              disabled={loading}
              autoComplete="off"
            />
          </div>
          <div className="field">
            <label className="field-label" htmlFor="body">Body</label>
            <textarea
              id="body"
              className="input"
              rows={6}
              value={body}
              onChange={(e) => setBody(e.target.value)}
              required
              disabled={loading}
              autoComplete="off"
            />
          </div>
        </form>
        : error ?
        <p>{error}</p>
        :
        <p>Command successfully updated.</p>
      }
    </ModalShell>
  );
};

export default UpdateCommandModal;
